import { Loading } from '@/components';
import { useMessage } from '@/providers';
import { logger } from '@/utils';
import { type FC, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router';
import { useCallbackGima } from '../hooks';

export const CallbackGimaPage: FC = () => {
  const [searchParams] = useSearchParams();
  const [cookies] = useCookies();
  const code = searchParams.get('code') ?? '';
  const state = searchParams.get('state') ?? '';
  const error = searchParams.get('error') ?? '';
  const res = useCallbackGima({ code, state });
  const { openMessage } = useMessage();
  const { t } = useTranslation();

  const isGimaError = error || !code || !state || res.isError;
  useEffect(() => {
    if (isGimaError) {
      logger.warn(
        'failed to login GIMA',
        { res, isGimaError },
        new Error('login-failed-gima'),
      );
      openMessage('warning', t('message-login-failed-gima'));
    }
  }, [isGimaError, openMessage, res, t]);

  if (res.isPending && code && state) {
    return <Loading />;
  }

  if (cookies.access_token) {
    return <Navigate replace to="/" />;
  }

  return <Navigate replace to="/login" />;
};
